import Backbone from "backbone";
import {pathname} from "../../common/others/Configuration";
import $ from "jquery";
import SharedDispatcher from "../../common/others/SharedDispatcher";

  export default Backbone.View.extend({

    events: {
      "click .js-ArticleCancel": "cancelArticle",
      "click .js-ArticleGuestCancel": "cancelGuestOrder"
    },

    cancelArticle: function (e) {
      e.preventDefault();
      var currentTarget = $(e.currentTarget);
      var orderRef = currentTarget.attr("data-orderref");
      var detailRef = currentTarget.attr("data-detailref");
      // TODO move to account configuration (as template URL)
      var cancelUrl = pathname + "/account/api/v1/order/CancelArticle";
      cancelUrl += '?orderReference=' + orderRef;
      cancelUrl += "&orderDetailReference=" + detailRef;
      
      $.post({
        url: cancelUrl,
        success: () => {
          this.$el.find(".js-ArticleCancelMsg").toggleClass("hide");
        },
        error: function () {
          SharedDispatcher.trigger("flashmessage:show");
        }
      });
      
    },

    cancelGuestOrder: function (e) {
      e.preventDefault();
      var currentTarget = $(e.currentTarget);
      var mainOrderRef = currentTarget.attr("data-mainorderref");
      // TODO move to account configuration (as template URL)
      var cancelUrl = pathname + "/account/api/v1/guestorder/cancel";
      cancelUrl += '/' + mainOrderRef;

      $.post({
        url: cancelUrl,
        success: () => {
          this.$el.find(".js-ArticleCancelMsg").toggleClass("hide");
        },
        error: function () {
          SharedDispatcher.trigger("flashmessage:show");
        }
      });

    },

  });


